import { FC, ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
	MplButton,
	PASSENGER_ANDROID_LINK,
	PASSENGER_IOS_LINK,
	StoreBadges,
} from '@mopla/ui';

import { Root, Title } from './PushToApp.styles';

interface IPushToAppProps {
	render: (p: { content: ReactNode; submit: ReactNode }) => ReactElement;
}

export const PushToApp: FC<IPushToAppProps> = ({ render }) => {
	const { t } = useTranslation('pushToApp');
	const navigate = useNavigate();

	return render({
		content: (
			<Root>
				<Title data-testid="welcomeScreen-appUpgrade-text">
					{t('text.title1')}
				</Title>
				<Title marginBottom="16px">{t('text.title2')}</Title>
				<Title marginBottom="24px">{t('text.title3')}</Title>
				<StoreBadges
					iosLink={PASSENGER_IOS_LINK}
					androidLink={PASSENGER_ANDROID_LINK}
				/>
			</Root>
		),
		submit: (
			<MplButton
				fullWidth
				variant="outlined"
				data-testid="app-upgrade-skip-button"
				onClick={() => navigate('/home')}
			>
				{t('button.to_home_page')}
			</MplButton>
		),
	});
};
